import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Text, Flex } from 'Components/Base';

import AttachmentOptionButton from './AttachmentOptionButton';

const DashLine = styled(Box)`
  border-bottom: 2px dashed ${({ theme }) => theme.colors.greyscale.grey4};
`;

const AttachmentFeedbackRating = ({
  options,
  onClickOption = () => {},
  selectedRating,
  ...restProps
}) => {
  return (
    <Box {...restProps}>
      <Flex alignItems="center">
        <DashLine style={{ flex: 1 }} />
        <Text
          style={{ flexShrink: '0' }}
          mx={3}
          textStyle={{ _: 'body1', sm: 'subtitle1' }}
          color="greyscale.grey3"
        >
          น้องคิดว่าคำอธิบายนี้ ช่วยให้เข้าใจมากน้อยแค่ไหน
        </Text>
        <DashLine style={{ flex: 1 }} />
      </Flex>
      <Flex justifyContent="center" mt={4}>
        {options.map((option) => (
          <AttachmentOptionButton
            key={option.value}
            option={option}
            isSelected={selectedRating === option.value}
            onClickOption={onClickOption}
          />
        ))}
      </Flex>
    </Box>
  );
};

AttachmentFeedbackRating.propTypes = {
  onClickOption: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
      icon: PropTypes.func,
    })
  ),
  selectedRating: PropTypes.number,
};

export default AttachmentFeedbackRating;
